var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 100,
    viewBox: "0 0 97 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.5839 34.315H59.8508L64.9994 19.1027C65.9291 16.3556 65.4592 13.3131 63.7397 10.9599C62.0202 8.60665 59.2309 7.2085 56.2917 7.2085H48.9037C47.544 7.2085 46.2544 7.80908 45.3746 8.83308L23.8204 34.3052H12.2134C7.15479 34.3052 3.0459 38.352 3.0459 43.3342V83.989C3.0459 88.9712 7.15479 93.018 12.2134 93.018H73.2372C77.0562 93.0081 80.4752 90.6746 81.8249 87.1595L94.4715 53.9582C94.6614 53.4462 94.7614 52.9145 94.7614 52.373V43.344C94.7614 38.3618 90.6525 34.315 85.5939 34.315H85.5839ZM12.2035 43.344H21.371V83.9989H12.2035V43.344ZM85.5839 51.5557L73.2372 83.989H30.5585V40.4591L51.0531 16.2374H56.3117L49.1436 37.387C48.3338 39.7501 49.6235 42.3003 52.0129 43.0979C52.4827 43.2554 52.9826 43.3342 53.4824 43.3342H85.5839V51.5458V51.5557Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.3c7b40e900033ab5b9a6d88aea36aa94.svg";
export { ForwardRef as ReactComponent };